import { Component, OnInit, DoCheck, Input } from '@angular/core';
import { COMMA, ENTER, F, TAB } from '@angular/cdk/keycodes';
import { Campaign }  from '../../models/campaign-wrapup-accumulators/campaign';
import { ConversationDetailQueryPredicateDimension, PredicateDimension, SegmentDetailQueryPredicateDimension }  from '../../constants/purecloud';
import * as $ from "jquery"
import Swal from 'sweetalert2'
import { CampaignWrapupAccumulatorsDataService } from 'src/app/services/campaign-wrapup-accumulators/campaign-wrapup-accumulators-data.service';
import { CampaignWrapupAccumulatorsExcelService } from 'src/app/services/campaign-wrapup-accumulators/campaign-wrapup-accumulators-excel.service';
import { CampaignWrapupAccumulatorsCloudService } from 'src/app/services/campaign-wrapup-accumulators/campaign-wrapup-accumulators-cloud.service';

declare const duallistboxCampaignWrapupAccumulators: any;
declare const duallistboxCampaignWrapupAccumulatorsDummy: any;

@Component({
  selector: 'app-campaign-wrapup-accumulators',
  templateUrl: './campaign-wrapup-accumulators.component.html',
  styleUrls: ['./campaign-wrapup-accumulators.component.css']
})
export class CampaignWrapupAccumulatorsComponent implements OnInit, DoCheck {
  readonly separatorKeysCodes = [ENTER, COMMA, TAB] as const;
  pickerFrom;
  myDatePickerFrom;
  pickerTo;
  myDatePickerTo;
  listCampaignSelected: any;
  selectedCampaigns: Campaign[] = [];
  allCampaigns: Array<Campaign>= [];
  campaignDummy: Array<Campaign>= [];
  duallistbox:any;

  constructor(private dataService : CampaignWrapupAccumulatorsDataService, private excelService : CampaignWrapupAccumulatorsExcelService, private cloudService : CampaignWrapupAccumulatorsCloudService) { }

  ngOnInit(): void {
    this.loadUsers();
  }
  loadCampaign(campaign) {
    this.allCampaigns.push({
      name: campaign.name,
      id: campaign.id
    });
  }
  loadUsers() {
    this.cloudService.getCampaigns()
    .then((response) => {
      response.forEach((user) => this.loadCampaign(user));
    })
    .catch((response) => alert(response));
  }

  ngDoCheck(): void {
    var duallistbox = $('.duallistbox-campaign-wrapup-accumulators');
    if(this.duallistbox == undefined && duallistbox[0].length > 0) {
      this.duallistbox = duallistbox;
      console.log(duallistbox);
      duallistboxCampaignWrapupAccumulatorsDummy.bootstrapDualListbox('destroy');
      $('.duallistbox-campaign-wrapup-accumulators-dummy').hide()

      duallistboxCampaignWrapupAccumulators.bootstrapDualListbox({
        moveOnSelect: false,
        infoTextEmpty: 'Lista vacia',
        infoText: false,
        filterPlaceHolder: 'Filtrar por campaña',
        moveSelectedLabel: 'Mover soleccionado',
        moveAllLabel: 'Mover todos',
        removeSelectedLabel: 'Borrar seleccionado',
        removeAllLabel: 'Borrar todos',
        infoTextFiltered: 'Filtrado {0} de {1}',
        filterTextClear: 'Mostrar todo'
      });
    }

    var listAgentSelected = $("#bootstrap-duallistbox-selected-list_campaigns");
    if(this.listCampaignSelected == undefined && listAgentSelected.length) {
      this.listCampaignSelected = listAgentSelected;

      const observer = new MutationObserver(
        () => { listAgentSelected.trigger('mutated') }
      )
      observer.observe(listAgentSelected[0], { childList: true })
      listAgentSelected.on('mutated', () => this.onCampaignChange())
    }

  }
  onCampaignChange(): void {
    this.selectedCampaigns = [];
    for (var i = 0; i < this.listCampaignSelected[0].length; i++) {
      var agent = this.listCampaignSelected[0][i];
      this.selectedCampaigns.push({name: agent.text, id: agent.value});
    }
  }

  onRangeDate(type: string): void {
    var now = new Date();
    switch(type) {
      case 'TODAY':
        this.myDatePickerFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
        this.myDatePickerTo = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
        break;
        case'YESTERDAY':
        this.myDatePickerFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 0, 0, 0, 0);
        this.myDatePickerTo = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
        break;
        case'LAST_7_DAYS':
        this.myDatePickerFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6, 0, 0, 0, 0);
        this.myDatePickerTo = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
        break;
        case'THIS_WEEK':
        this.myDatePickerFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay() + 1, 0, 0, 0, 0);
        this.myDatePickerTo = new Date(this.myDatePickerFrom.getFullYear(), this.myDatePickerFrom.getMonth(), this.myDatePickerFrom .getDate() + 7, 0, 0, 0, 0);
        break;
        case'PREVIOUS_WEEK':
        this.myDatePickerFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay() - 7 + 1, 0, 0, 0, 0);
        this.myDatePickerTo = new Date(this.myDatePickerFrom.getFullYear(), this.myDatePickerFrom.getMonth(), this.myDatePickerFrom.getDate() + 7, 0, 0, 0, 0);
        break;
        case'LAST_31_DAYS':
        this.myDatePickerFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30, 0, 0, 0, 0);
        this.myDatePickerTo = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
        break;
      default:
    }
  }

  async onGenerateCampaignWrapupAccumulators() {
    console.info('pickerFrom: ' + this.pickerFrom + ', myDatePickerFrom: ' + this.myDatePickerFrom + ', pickerTo: ' + this.pickerTo + ', myDatePickerTo: ' + this.myDatePickerTo);
    if(this.myDatePickerFrom == undefined || this.myDatePickerTo == undefined) {
      Swal.fire({
        title: 'Cancelado',
        html: 'Se cancelo la tarea por... <b>No se definio rango de fechas correctamente</b>',
      }).then((result) => {
        console.log(result);
      })
      return;
    }
    
    var listAgentNoSelected = $("#bootstrap-duallistbox-nonselected-list_campaigns");
    if(listAgentNoSelected[0].length > 0 && this.selectedCampaigns.length > 100) {
      Swal.fire({
        title: 'Cancelado',
        html: 'Se cancelo la tarea por... <b>Se supero la cantidad de campañas permitidas: 100</b>',
      }).then((result) => {
        console.log(result);
      })
      return;
    }

    var from = new Date(this.myDatePickerFrom); //new Date(2021, 4, 23, 3, 0, 0,0); //'2021-04-23T03:00:00.000Z'
    var to = new Date(this.myDatePickerTo); //new Date(2021, 4, 24, 3, 0, 0,0); //'2021-04-24T03:00:00.000Z'

    from.setHours(from.getHours() + 3);
    to.setHours(to.getHours() + 3);

    var selectedIdCampaigns = [];
    var selectedMapCampaigns = {};
    for (var i = 0; i < this.selectedCampaigns.length; i++) {
      selectedIdCampaigns.push(this.selectedCampaigns[i].id);
    }
    for (var i = 0; i < this.allCampaigns.length; i++) {
      selectedMapCampaigns[this.allCampaigns[i].id] = this.allCampaigns[i].name;
    }

    let wraups = await this.cloudService.getWraUps();

    var predicate = {};
    predicate[PredicateDimension.conversation] = {}
    predicate[PredicateDimension.conversation][ConversationDetailQueryPredicateDimension.originatingDirection] = ['outbound'];
    predicate[PredicateDimension.conversation][ConversationDetailQueryPredicateDimension.conversationEnd] = [];
    predicate[PredicateDimension.segment] = {}
    predicate[PredicateDimension.segment][SegmentDetailQueryPredicateDimension.outboundCampaignId] = selectedIdCampaigns;

    this.dataService.generate(from, to, predicate, true)
    .then((response) => this.processExcel(response, new Date(this.myDatePickerFrom), new Date(this.myDatePickerTo), selectedMapCampaigns, wraups))
    .catch(function(response) {
      Swal.fire({
        title: 'Cancelado',
        html: 'Se cancelo la tarea por... <b></b>',
        didOpen: () => {
          Swal.showLoading();
          const content = Swal.getContent();
          if (content) {
            const b = content.querySelector('b');
            if (b) {
              console.log(response);
              var result = undefined;
              if(response.body !== undefined && response.body.message !== undefined) {
                result = response.body.message
              }
              if(response.error !== undefined && response.error.message !== undefined) {
                result = response.error.message + " (" + response.error.errno + ")";
              }
              if(result === undefined) {
                result = response;
              }
              b.textContent = JSON.stringify(result);
            }
          }
        },
        willClose: () => {
          window.location.href = window.location.href
        }
      }).then((result) => {
        console.log(result);
      })
    });
  }

  private processExcel(response : Array<any>, from : Date, to : Date, selectedMapCampaigns, wraups): void {

 

      let reporte = response[0]
      if(reporte === undefined) {
        reporte = {};
        response.push(reporte);
      }

      if(reporte.wrapUpCodes === undefined) {
        reporte.wrapUpCodes = {};
      }
      if(reporte.wrapUpRows === undefined) {
        reporte.wrapUpRows = [];
      }
      const keys = Object.keys(reporte.wrapUpCodes);

      keys.forEach(key => {
        var name = wraups[key];
        var value = reporte.wrapUpCodes[key];
        if(name === undefined) {
          name = key;
        }
        delete reporte.wrapUpCodes[key];
        reporte.wrapUpCodes[name] = value;
      });

      const keysRow = Object.keys(reporte.wrapUpRows);
      keysRow.forEach(key => {
        var name = wraups[reporte.wrapUpRows[key].wrapUpCode]
        if(name === undefined) {
          name = reporte.wrapUpRows[key].wrapUpCode;
        }
        reporte.wrapUpRows[key].wrapUpCode = name
      });


    this.excelService.exportExcel(response, from, to);
  }
}
